<template>
  <div :class="{ active: show }" class="modal-properties">
    <div v-if="modal">
      <div>
        <h2>{{ parseTranslation(SURVEY_PROPERTIES) }}</h2>
        <p>
          <span>{{ parseTranslation(NAME) }}: </span>
          {{ modal.info.name }}
        </p>
        <p>
          <span>{{ parseTranslation(LANGUAGE) }}: </span> {{ modal.info.lang }}
        </p>
        <p>
          <span>{{ parseTranslation(OWNER) }}: </span> {{ modal.info.owner }}
        </p>
        <p>
          <span>{{ parseTranslation(SURVEY_ID) }}: </span> {{ modal.info.id_ }}
        </p>
        <p>
          <span>{{ parseTranslation(SURVEY_TYPE) }}: </span>
          {{ modal.info.survey_type }}
        </p>
        <p>
          <span>{{ parseTranslation(LAST_UPDATE) }}: </span>
          {{ modal.info.last_updated }}
        </p>
      </div>
      <button @click="closeModal">{{ parseTranslation(CLOSE) }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationModalProperties from './ModalProperties.translations'
const { default: translations, ...translationKeys } = translationModalProperties

export default {
  data() {
    return {
      translations,
      ...translationKeys,
      show: false,
    }
  },

  computed: {
    modal() {
      return this.$store.getters.modalProperties
    },
  },

  watch: {
    modal() {
      if (this.modal) {
        this.openModal()
      }
    },
  },

  methods: {
    ...mapActions(['modalProperties']),

    openModal() {
      this.show = true
    },

    closeModal() {
      this.show = false
      this.modalProperties(null)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-properties {
  @include background-modal-config;

  &.active {
    display: flex;
  }

  > div {
    @include modal-config(600);

    h2 {
      margin-bottom: 20px;
      @include tipography(24);
      font-weight: bold;

      .light & {
        color: $main-two;
      }
    }

    p {
      @include tipography(16);
      margin-bottom: 10px;

      span {
        font-weight: bold;
        margin-right: 5px;
      }

      .light & {
        color: $main-two;
      }
    }

    button {
      margin-top: 20px;
      padding: 8px 15px;
      border-radius: 3px;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      font-weight: 600;
      @include tipography(14);
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
      background: $blue;
      color: $white;
      border: none;

      &:hover {
        background: $blue-2;
        transform: scale(1.01);
      }

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
